export default class DateUtils {
  static getTimeDifferenceInMinutes(
    startTime: string,
    endTime: string
  ): number {
    const difference =
      new Date(endTime).getTime() - new Date(startTime).getTime();

    return Math.floor(difference / 1000 / 60);
  }

  static padTo2Digits(num: number): string {
    return num.toString().padStart(2, '0');
  }

  /**
   * @param {Date} date
   * @returns {string} datetime to dd.mm.yyyy hh:mm
   */
  static convertDateTimeToNO(date: Date, hideHoursAndMinutes = false): string {
    const fullDate = [
      DateUtils.padTo2Digits(date.getDate()),
      DateUtils.padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join('.');
    const time = [
      DateUtils.padTo2Digits(date.getHours()),
      DateUtils.padTo2Digits(date.getMinutes()),
    ].join(':');
    return hideHoursAndMinutes ? fullDate : fullDate + ' ' + time;
  }

  /**
   * @param {Date} date
   * @returns {string} datetime to string hh:mm
   */
  static getTimeString(date: Date): string {
    const time = [
      DateUtils.padTo2Digits(date.getHours()),
      DateUtils.padTo2Digits(date.getMinutes()),
    ].join(':');
    return time;
  }

  /**
   * @param {Date} date
   * @returns {string} - date format yyyy-mm-dd
   */
  static convertDate(date: Date): string {
    const yyyy = date.getFullYear().toString();
    const mm = (date.getMonth() + 1).toString();
    const dd = date.getDate().toString();

    const mmChars = mm.split('');
    const ddChars = dd.split('');

    return (
      yyyy +
      '-' +
      (mmChars[1] ? mm : '0' + mmChars[0]) +
      '-' +
      (ddChars[1] ? dd : '0' + ddChars[0])
    );
  }
  /**
   * Some features are using NO time only from BE.
   * This util is used in such cases - it takes current NO time and converts it into
   * BE matching string.
   * @returns {string} - date format matching BE format: yyyy-mm-ddThh:mm:ss
   */
  static getCurrentNOTime(): string {
    const noLocaleTime = new Date().toLocaleString('no', {
      timeZone: 'Europe/Oslo',
    });

    const dateArr = noLocaleTime.split(',')[0].split('.');

    return (
      dateArr[2] +
      '-' +
      (Number(dateArr[1]) < 10 ? 0 + dateArr[1] : dateArr[1]) +
      '-' +
      (Number(dateArr[0]) < 10 ? 0 + dateArr[0] : dateArr[0]) +
      'T' +
      noLocaleTime.split(',')[1].trim()
    );
  }
}
